<template>

    <m-edit1/>

    <m-nav-4 v-bind='{...{},...{}}' :style='""' class="nav-4" ></m-nav-4><m-div v-bind='{...{},...{}}' :style='"background: var(--secondary);"' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="p-0 mx-auto m-0 container" >
                <template #default>   <m-nav-2 v-bind='{...{"shoppingCart":true,"dashboardLink":"https:\/\/dash.roshdfarms.ir\/dashboard"},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-nav-2></template>
                </m-div></template>
                </m-div><m-nav-305 v-bind='{...{},...{}}' :style='""' class="" ></m-nav-305><m-loading-3 v-bind='{...{},...{}}' :style='""' class="" ></m-loading-3><m-update-site-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-update-site-message-1><router-view name='site' v-bind='{...{},...{}}' :style='""' class='""' /><m-div v-bind='{...{},...{}}' :style='""' class="f100 py-5" >
                <template #default>   <m-footer-100 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>default   </template>
                </m-footer-100></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mNav4 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav4'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mNav2 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav2/Nav2'; import mNav305 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav305/Nav305'; import mLoading3 from '@moeinmdn/miw-alpha-components/src/package/Loading/Loading3'; import mUpdateSiteMessage1 from '@moeinmdn/miw-alpha-components/src/package/UpdateSiteMessage/UpdateSiteMessage1'; import mFooter100 from '@moeinmdn/miw-alpha-components/src/package/Footers/Footer100/Footer100';

export default {
    name: 'HomeView',
    components: {mEdit1, mNav4,mDiv,mNav2,mNav305,mLoading3,mUpdateSiteMessage1,mFooter100 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
